export const MF_CONTENTSTACK_TAG = 'mf';
